<h2 mat-dialog-title class="train-modal-title">
  🚆 Los trenes ya están en Vyootrip
</h2>

<div class="train-modal-content">
  <p class="train-modal-subtitle">
    Reserva billetes de tren directamente desde la plataforma en cuestión de segundos.
  </p>

  <ul class="train-benefits">
    <li>✅ Más disponibilidad</li>
    <li>✅ Mejores tarifas</li>
    <li>✅ Todo tu viaje en un único lugar</li>
  </ul>

  <img
    src="assets/img/trains/trains_new.png"
    alt="Trenes en Vyootrip"
    class="train-modal-image"
  />
</div>